/* eslint-env browser*/
/* global Promise jQuery */

import superagent from 'superagent';

import xmlToJson from './xml_to_json';

/*
For authenticated URL.
const BASE = 'https://apis.berkeley.edu/coolclimate';
const KEY_ID = '15a335b6';
const KEY = '26ffc87cf832d3d2c6dfb6241a88937a';
*/

const defaultBasePath = () => {
  switch (true) {
    case window.location.hostname.search('nginx') >= 0:
    case window.location.hostname.search('localhost') >= 0:
    case window.location.hostname.search('127.0.0.1') >= 0:
      return 'https://coolclimate.berkeley.edu/calculators/household-staging/api.php';
    default:
      return 'https://coolclimate.berkeley.edu/calculators/household-staging/api.php';
  }
};

const BASE = defaultBasePath();
const APP_TOKEN = 'DPP6zZDkSQAlRKfQ-iWgdg';

class CalculatorApi {

  static compute(payload, op) {
    return new Promise((fnResolve, fnReject) => {
      const params = { op };
      superagent.post(BASE)
                .set('X-DEV-TOKEN', APP_TOKEN)
                .set('Accept', 'application/x-www-form-urlencoded; charset=UTF-8')
                .query(params)
                .send(jQuery.param(payload))
                .end((err, res) => {
                  if (err) fnReject(err);
                  else {
                    const xml = new DOMParser().parseFromString(res.text, 'application/xml');
                    const parsed = xmlToJson(xml);
                    fnResolve(parsed.response);
                  }
                });
    });
  }

  /* eg: location = {
    input_location: 06704,
    input_location_mode: 1,
    input_income: 1,
    input_size: 3}
    */
  static getDefaultsAndResults(location) {
    const params = Object.assign({
      op: 'get_defaults_and_results',
    }, location);
    return new Promise((fnResolve, fnReject) => {
      superagent.get(BASE)
                .set('X-DEV-TOKEN', APP_TOKEN)
                .set('Accept', 'application/xml')
                .query(params)
                .end((err, res) => {
                  if (err) fnReject(err);
                  else {
                    const xml = new DOMParser().parseFromString(res.text, 'application/xml');
                    const parsed = xmlToJson(xml);
                    fnResolve(parsed.response);
                  }
                });
    });
  }

  static getAutocomplete(term, mode = 1) {
    const params = Object.assign({
      op: 'get_auto_complete',
      input_location_mode: mode,
      input_location: term,
    });
    return new Promise((fnResolve, fnReject) => {
      superagent.get(BASE)
                .set('X-DEV-TOKEN', APP_TOKEN)
                .set('Accept', 'application/json')
                .query(params)
                .end((err, res) => {
                  if (err) fnReject(err);
                  else {
                    const parsed = JSON.parse(res.text);
                    const locations = parsed.selected_location.map((l, i) => ({
                      ...l,
                      description: parsed.suggestions[i],
                      input_location_mode: mode,                      
                      key: parsed.data[i],
                    }));
                    fnResolve(locations);
                  }
                });
    });
  }


  static getAvailableLocations(payload) {
    const params = Object.assign({
      op: 'get_available_locations',
    }, location);
    return new Promise((fnResolve, fnReject) => {
      superagent.post(BASE)
                .set('X-DEV-TOKEN', APP_TOKEN)
                .set('Accept', 'application/json')
                .query(params)
                .send(payload)
                .end((err, res) => {
                  if (err) fnReject(err);
                  else {
                    const parsed = JSON.parse(res.text);
                    fnResolve(parsed);
                  }
                });
    });
  }

}

export default CalculatorApi;
